import { NTSReflection } from '@nts/std/src/lib/utility';
import { ClassType } from '../../serialization';

const EXTERNAL_DOMAIN_MODEL_TYPE_META_DATA_IDENTIFICATION_KEY = 'externalDomainModelTypeDecoratorMetaDataKey';

export function ExternalDomainModelTypeDecorator(externalDomainModelType: ClassType<any>) {
    return (target: any) => {
        Reflect.defineMetadata(EXTERNAL_DOMAIN_MODEL_TYPE_META_DATA_IDENTIFICATION_KEY, externalDomainModelType, target);
    };
}

export class ExternalDomainModelTypeInspector {

    static META_DATA_KEY = EXTERNAL_DOMAIN_MODEL_TYPE_META_DATA_IDENTIFICATION_KEY;
    static DECORATOR_NAME = '@ExternalDomainModelTypeDecorator';

    static isApplied(subject: any): boolean {
        return NTSReflection.hasClassMetadata(
            EXTERNAL_DOMAIN_MODEL_TYPE_META_DATA_IDENTIFICATION_KEY, subject);
    }

    static getValue(subject: any): ClassType<any> {
        return NTSReflection.getClassMetadata(
            EXTERNAL_DOMAIN_MODEL_TYPE_META_DATA_IDENTIFICATION_KEY, subject);
    }
}
